import { render, staticRenderFns } from "./DetailDelivery.vue?vue&type=template&id=1c9daf64&scoped=true&"
import script from "./DetailDelivery.vue?vue&type=script&lang=ts&"
export * from "./DetailDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./DetailDelivery.vue?vue&type=style&index=0&id=1c9daf64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9daf64",
  null
  
)

export default component.exports